(function () {
  'use strict';

  var CODES = { 1: 'YOYO10', 2: 'YOYO20', 3: '' };

  function fmt(cents) {
    var n = Math.round(cents) / 100;
    return '\u20b9' + n.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function initBlock(wrap) {
    if (wrap._psb) return;
    wrap._psb = true;

    var blockId   = wrap.dataset.blockId;
    var disc1     = parseFloat(wrap.dataset.plan1Discount) || 0;  /* 10% */
    var disc2     = parseFloat(wrap.dataset.plan2Discount) || 0;  /* 20% */
    var origPrice = parseInt(wrap.dataset.originalPrice, 10) || 0;

    /* Fixed box counts per plan — never change */
    var PLAN1_BOXES = 1;
    var PLAN2_BOXES = 2;

    /* DOM refs */
    var plans    = wrap.querySelectorAll('.psb__plan');
    var pills    = wrap.querySelectorAll('.psb__fpill');
    var dl1      = wrap.querySelector('.psb__disc-line--1');
    var dl2      = wrap.querySelector('.psb__disc-line--2');
    var liveBox  = document.getElementById('psb-live-' + blockId);
    var liveAmt  = liveBox ? liveBox.querySelector('.psb__live-amount') : null;
    var liveSave = liveBox ? liveBox.querySelector('.psb__live-saving') : null;
    var atcBtn   = document.getElementById('psb-atc-' + blockId);
    var atcSub   = atcBtn ? atcBtn.nextElementSibling : null;

    /* State */
    var S = {
      plan  : 1,
      price : origPrice,  /* price per unit in paise/cents */
      title : '',
      avail : true,
      varId : null,
      qty   : 1           /* quantity selector value */
    };

    /* Seed price from first flavor pill */
    var firstPill = wrap.querySelector('.psb__fpill');
    if (firstPill) {
      S.varId  = parseInt(firstPill.dataset.variantId, 10) || null;
      S.price  = parseInt(firstPill.dataset.variantPrice, 10) || origPrice;
      S.title  = firstPill.dataset.variantTitle || '';
      S.avail  = firstPill.dataset.variantAvailable !== 'false';
    }

    /* ══════════════════════════════════════════════════
       RENDER — only updates LIVE PRICE BOX
       Plan cards are NEVER touched here
    ══════════════════════════════════════════════════ */
    function render() {
      var unitPrice = S.price || origPrice;  /* price of 1 unit */
      var qty       = S.qty || 1;
      var plan      = S.plan;

      var boxes, disc, total, saving, code;

      if (plan === 1) {
        /* Most Popular: 1 box × qty × price → 10% off */
        boxes  = PLAN1_BOXES;
        disc   = disc1;
        total  = Math.round(unitPrice * boxes * qty);
        saving = Math.round(total * disc / 100);
        total  = total - saving;
        code   = CODES[1];
      } else if (plan === 2) {
        /* Best Value: 2 boxes × qty × price → 20% off */
        boxes  = PLAN2_BOXES;
        disc   = disc2;
        total  = Math.round(unitPrice * boxes * qty);
        saving = Math.round(total * disc / 100);
        total  = total - saving;
        code   = CODES[2];
      } else {
        /* Buy It Once: 1 box × qty × price → no discount */
        boxes  = 1;
        disc   = 0;
        total  = Math.round(unitPrice * boxes * qty);
        saving = 0;
        code   = '';
      }

      /* Update live price box */
      if (liveAmt) liveAmt.textContent = fmt(total);
      if (liveSave) {
        if (saving > 0) {
          liveSave.textContent = 'You save ' + fmt(saving) + ' (' + disc + '% off)';
          liveSave.style.display = '';
        } else {
          liveSave.textContent = '';
          liveSave.style.display = 'none';
        }
      }

      /* ── Update Plan 1 card price (variant price × 1 box × disc1) ── */
      var p1CardBase  = Math.round(unitPrice * PLAN1_BOXES);
      var p1CardFinal = Math.round(p1CardBase * (1 - disc1/100));
      var p1el = wrap.querySelector('.psb__price--plan1');
      if (p1el) {
        p1el.innerHTML = disc1 > 0
          ? '<s class="psb__compare">' + fmt(p1CardBase) + '</s> ' + fmt(p1CardFinal)
          : fmt(p1CardBase);
      }

      /* ── Update Plan 2 card price (variant price × 2 boxes × disc2) ── */
      var p2CardBase  = Math.round(unitPrice * PLAN2_BOXES);
      var p2CardFinal = Math.round(p2CardBase * (1 - disc2/100));
      var p2el = wrap.querySelector('.psb__price--plan2');
      if (p2el) {
        var p2cmp = p2el.querySelector('.psb__compare');
        var p2fin = p2el.querySelector('.psb__p2-final');
        if (p2cmp) p2cmp.textContent = fmt(p2CardBase);
        if (p2fin) p2fin.textContent = fmt(p2CardFinal);
        if (!p2cmp || !p2fin) {
          p2el.innerHTML = '<s class="psb__compare">' + fmt(p2CardBase) + '</s> <span class="psb__p2-final">' + fmt(p2CardFinal) + '</span>';
        }
      }

      /* Show correct discount line inside selected plan card */
      if (dl1) dl1.style.display = (plan === 1 && disc1 > 0) ? '' : 'none';
      if (dl2) dl2.style.display = (plan === 2 && disc2 > 0) ? '' : 'none';

      /* ATC sub text */
      if (atcSub) {
        atcSub.textContent = code ? code + ' applied automatically at checkout' : '';
        atcSub.style.display = code ? '' : 'none';
      }

      /* ATC button */
      if (atcBtn) {
        var lbl = atcBtn.dataset.label || 'Add to Cart';
        atcBtn.disabled    = !S.avail;
        atcBtn.textContent = S.avail ? lbl : 'Sold Out';
      }
    }

    /* ══════════════════════════════════════════════════
       SELECT PLAN
    ══════════════════════════════════════════════════ */
    function selectPlan(n) {
      S.plan = n;

      /* Update radio + border on cards */
      plans.forEach(function (p) {
        var isSel = parseInt(p.dataset.plan, 10) === n;
        p.classList.toggle('psb__plan--active', isSel);
        var r = p.querySelector('.psb__radio');
        if (r) r.classList.toggle('psb__radio--on', isSel);
      });

      /* Show flavor picker only on plan 1 */
      var fp = wrap.querySelector('.psb__flavors');
      if (fp) fp.style.display = n === 1 ? '' : 'none';

      render();
    }

    /* ══════════════════════════════════════════════════
       SELECT FLAVOR / VARIANT
    ══════════════════════════════════════════════════ */
    function selectFlavor(pill) {
      pills.forEach(function (p) { p.classList.remove('psb__fpill--active'); });
      pill.classList.add('psb__fpill--active');

      S.varId  = parseInt(pill.dataset.variantId, 10);
      S.price  = parseInt(pill.dataset.variantPrice, 10) || origPrice;
      S.title  = pill.dataset.variantTitle || '';
      S.avail  = pill.dataset.variantAvailable !== 'false';

      /* Sync Shopify native variant input */
      var ni = document.querySelector('input[name="id"]');
      if (ni && parseInt(ni.value, 10) !== S.varId) {
        ni.value = S.varId;
        ni.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /* Update URL */
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', S.varId);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}

      if (S.plan !== 1) selectPlan(1);
      else render();
    }

    /* ══════════════════════════════════════════════════
       UPDATE QUANTITY
    ══════════════════════════════════════════════════ */
    function updateQty(dir) {
      var next = (parseInt(S.qty, 10) || 1) + dir;
      if (next < 1 || next > 10) return;
      S.qty = next;
      var display = wrap.querySelector('.psb__qty-num');
      if (display) display.textContent = next;
      render();
    }

    /* ══════════════════════════════════════════════════
       ADD TO CART
    ══════════════════════════════════════════════════ */
    function addToCart() {
      var id = S.varId || (function () {
        var ni = document.querySelector('input[name="id"]');
        return ni ? parseInt(ni.value, 10) : null;
      })();
      if (!id) return;

      var origLabel = atcBtn ? (atcBtn.dataset.label || 'Add to Cart') : 'Add to Cart';
      if (atcBtn) { atcBtn.textContent = 'Adding...'; atcBtn.disabled = true; }

      var boxes   = S.plan === 2 ? PLAN2_BOXES : PLAN1_BOXES;
      var cartQty = boxes * (S.qty || 1);
      var pct     = S.plan === 1 ? disc1 : S.plan === 2 ? disc2 : 0;
      var code    = CODES[S.plan] || '';

      var props = {
        'Plan': S.plan === 1 ? 'Subscribe 1 Box' : S.plan === 2 ? 'Subscribe 2 Box' : 'One-time'
      };
      if (S.title) props['Flavor']   = S.title;
      if (pct > 0) props['Discount'] = pct + '% off';
      if (code)    props['Code']     = code;

      /* Save discount in cookie */
      if (code) {
        document.cookie = 'discount_code=' + code + '; path=/; max-age=86400; samesite=lax';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: cartQty, properties: props })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.id || (data.items && data.items.length)) {
          if (atcBtn) {
            atcBtn.textContent      = '✓ Added!';
            atcBtn.style.background = '#22c55e';
            atcBtn.style.color      = '#fff';
            setTimeout(function () {
              atcBtn.textContent      = origLabel;
              atcBtn.style.background = '';
              atcBtn.style.color      = '';
              atcBtn.disabled         = false;
            }, 2500);
          }
          /* Open cart drawer */
          var cartIcon = document.getElementById('cart-icon-bubble')
            || document.querySelector('[data-cart-toggle]')
            || document.querySelector('a[href="/cart"].header__icon');
          if (cartIcon) cartIcon.click();

          /* Update cart count */
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden)').forEach(function (b) {
              b.textContent = cart.item_count;
            });
          });
        } else {
          alert(data.description || data.message || 'Could not add to cart.');
          if (atcBtn) { atcBtn.textContent = origLabel; atcBtn.disabled = false; }
        }
      })
      .catch(function () {
        if (atcBtn) { atcBtn.textContent = origLabel; atcBtn.disabled = false; }
        window.location.href = '/cart';
      });
    }

    /* ══════════════════════════════════════════════════
       EVENT LISTENERS
    ══════════════════════════════════════════════════ */

    /* Plan card click */
    plans.forEach(function (plan) {
      plan.addEventListener('click', function (e) {
        if (e.target.closest('.psb__fpill'))   return;
        if (e.target.closest('.psb__qty-btn')) return;
        selectPlan(parseInt(plan.dataset.plan, 10));
      });
    });

    /* Flavor pill click */
    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.stopPropagation();
        if (pill.dataset.variantAvailable === 'false') return;
        selectFlavor(pill);
      });
    });

    /* Qty minus */
    var qtyMinus = wrap.querySelector('[aria-label="Decrease quantity"]');
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        updateQty(-1);
      });
    }

    /* Qty plus */
    var qtyPlus = wrap.querySelector('[aria-label="Increase quantity"]');
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        updateQty(1);
      });
    }

    /* ATC button */
    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart();
      });
    }

    /* Sync theme native variant picker */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') {
        var newId = parseInt(e.target.value, 10);
        pills.forEach(function (p) {
          if (parseInt(p.dataset.variantId, 10) === newId) selectFlavor(p);
        });
      }
    });

    /* ── INIT ── */
    if (dl1 && disc1 > 0) dl1.style.display = '';
    if (dl2) dl2.style.display = 'none';
    render();
  }

  /* Boot */
  function boot() { document.querySelectorAll('.psb').forEach(initBlock); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.psb').forEach(initBlock); });
  document.addEventListener('shopify:block:select', function (e) {
    var r = e.target.querySelector('.psb') || e.target.closest('.psb');
    if (r) initBlock(r);
  });

})();
